define.alias("shared/components/shared/mobile/drawer/carousel-card", "media/components/shared/mobile/drawer/carousel-card");